import { memberApi } from '@formosa/shared/api/member';

/**
 * Travel media upload. Ownership is MemberUploadController
 * {@code POST /formosa-member/member/common/upload/oss/travel/image}.
 * Server fixes prefix {@code travel/image/}. Returns objectKey only.
 */
export const travelMediaApi = {
  uploadImage: (file) => memberApi.uploadOssTravelImage(file),
};
